import { IconSVG } from '@components/IconSVG';
import { Text } from '@components/Typography';
import * as React from 'react';
import styled from 'styled-components';

export const StyledCarouselItem = styled.a`
  display: flex;
  flex-direction: row;
  width: 100%;
  cursor: pointer;
  padding-left: 5px;
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-left: 10px;
  }
`;

const StyledImageWrapper = styled.div`
  width: 35px;
  height: auto;
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 36px;
  }
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: fit-content;
  margin-left: 0.75rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-left: 0.75rem;
  }
`;

interface Props {
  data: {
    title?: string;
    url?: string;
    author?: string;
    type?: string;
  };
}

export const CarouselItem = ({ data: { url, title, type, author } }: Props): JSX.Element => {
  return (
    <StyledCarouselItem href={`${url}`} target="_blank">
      <StyledImageWrapper>
        <IconSVG variant={type} />
      </StyledImageWrapper>
      <StyledContent>
        <Text as="p" variant="default" size="xs" weight="bold">
          {title}
        </Text>
        <Text as="p" variant="default" size="xs">
          {author}
        </Text>
      </StyledContent>
    </StyledCarouselItem>
  );
};
